export const SEMI_FLEX_PAYMENT_LABEL = 'Semi-Flex';

const resolveSemiFlexConsumption = (booking) => {
    const qty = Number(booking?.semi_flexible_quantity);
    const unit = booking?.semi_flexible_unit;

    if (Number.isFinite(qty) && qty > 0 && unit) {
        return { qty, unit };
    }

    if (!booking?.semi_flexible_booking) {
        return null;
    }

    const datesQty = Math.max(1, booking.multiple_date ? (booking.dates?.length || 1) : 1);
    const hoursQty = Math.max(0, Number(booking.hours_quantity) || 0);
    const guestCount = Math.max(1, Number(booking.space_quantity) || 1);

    if (booking.hourly) {
        return { qty: hoursQty > 0 ? hoursQty : 1, unit: 'hours' };
    }

    return { qty: datesQty * guestCount, unit: 'days' };
};

export const formatSemiFlexConsumption = (booking) => {
    const consumption = resolveSemiFlexConsumption(booking);

    if (!consumption) {
        return '-';
    }

    const { qty, unit } = consumption;

    if (unit === 'hours') {
        return `${qty} ${qty === 1 ? 'hora' : 'horas'}`;
    }

    return `${qty} ${qty === 1 ? 'jornada' : 'jornadas'}`;
};
